import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { BaseUser, BaseUserNotificationSettings } from '@common/react/objects/BaseUser';

export const UpdateUserNotificationsRequest = 'updateUserNotifications';

const BrowserNotificationChecker: React.FC = () => {
	const { getUser } = useApplicationContext();
	const user = getUser<BaseUser & BaseUserNotificationSettings>();

	const askNotificationPermission = () => {
		if (!('Notification' in window)) {
			return;
		}

		// eslint-disable-next-line
		Notification.requestPermission().then(() => {});
	};

	React.useEffect(() => {
		if ('Notification' in window && user?.browserNotifications && Notification.permission !== 'granted') {
			askNotificationPermission();
		}
	}, [user?.id]);

	return <></>;
};

export default BrowserNotificationChecker;
